import { customDispatch } from "@affinity/Store/ServiceBase";
import { PlaceOrderStep } from "@affinity/Store/StoreTypes";
import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";

// External parameters
type HandlerType = Handler<{
    step: PlaceOrderStep;
}>;

export const PlaceOrderRevertToStep: HandlerType = ({ dispatch, parameter: { step } }) => {
    (dispatch as customDispatch)({
        type: "Affinity/RevertToStep",
        step
    });
};

export const Tracking: HandlerType = props => {
};

export const chain = [PlaceOrderRevertToStep, Tracking];

const placeOrderRevertToStep = createHandlerChainRunner(chain, "PlaceOrderRevertToStep");
export default placeOrderRevertToStep;